export default "__VITE_ASSET__CF08IUzs__"